module.exports = new __parcel__URL__("send.ff69eaa4.svg").toString();